// client/src/pages/AdminCMS.jsx

import React, { useState } from "react";
import ManageImages from "../components/admin/ManageImages";
import ManageDocuments from "../components/admin/ManageDocuments";
import ManageVideos from "../components/admin/ManageVideos";
import ManageBlogPosts from "../components/admin/ManageBlogPosts";
import ManageAudio from "../components/admin/ManageAudio";
import ManageResources from "../components/admin/ManageResources";
import ManageAnnouncements from "../components/admin/ManageAnnouncements";
import ManageEvents from "../components/admin/ManageEvents";
import { Link, useNavigate } from "react-router-dom";
import useAuthCheck from "../components/useAuthCheck";
import AdminUserManagement from "../components/admin/AdminUserManagement";
import ManagePages from "../components/admin/ManagePages";

const AdminCMS = () => {
    useAuthCheck();

    const [activeTab, setActiveTab] = useState("announcements");

    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/login");
    };

    const tabs = [
        { key: "announcements", label: "Announcements", component: <ManageAnnouncements /> },
        { key: "events", label: "Events", component: <ManageEvents /> },
        { key: "pages", label: "Pages", component: <ManagePages/> },
        // { key: "images", label: "Private Images", component: <ManageImages /> },
        // { key: "documents", label: "Documents", component: <ManageDocuments /> },
        // { key: "videos", label: "Videos", component: <ManageVideos /> },
        { key: "blogPosts", label: "Blog Posts", component: <ManageBlogPosts /> },
        // { key: "audio", label: "Audio", component: <ManageAudio /> },
        { key: "users", label: "Users", component: <AdminUserManagement /> },

    ];



    return (
        <div className="container mx-auto py-16">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-4xl font-bold mb-4">Admin Content Management System</h1>
                <Link
                    to="/members/dashboard"
                    className="bg-red-500 text-white px-4 py-2 rounded-lg"
                >
                    Dashboard
                </Link>
            </div>
            <div className="flex flex-wrap justify-center gap-2 mb-6">
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        className={`px-4 py-2 rounded ${
                            activeTab === tab.key ? "bg-blue-500 text-white" : "bg-gray-200"
                        }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div>{tabs.find((tab) => tab.key === activeTab)?.component}</div>
            <div className="p-4 text-center">
                <button
                    onClick={handleLogout}
                    className="bg-red-500 text-white px-4 py-2 rounded-lg"
                >
                    Logout
                </button>
            </div>
        </div>
    );
};

export default AdminCMS;
